import { AxiosResponse } from 'axios';
import {
  SavedSearchCriteriaCommonModel,
  SavedSearchCriteriaListResponse,
  SavedSearchCriteriaResponse,
} from 'types/entity';
import { http } from './settings';

/**
 *  (006001) 保存済み検索条件一覧取得
 * @param projectId
 */
export const fetchSavedSearchCriterias = (
  projectId: string,
): Promise<SavedSearchCriteriaResponse[]> => http.get(`/projects/${projectId}/search-criterias`)
  .then((value: AxiosResponse<SavedSearchCriteriaListResponse>) => value.data.savedSearchCriterias || []);

/**
 * (006004) 保存済み検索条件追加更新
 * @param projectId
 * @param criteria
 */
export const putSearchCriteria = (projectId: string, criteria: SavedSearchCriteriaCommonModel): Promise<SavedSearchCriteriaResponse> => http.put(`/projects/${projectId}/search-criterias/${criteria.search_criteria_id}`, criteria)
  .then((response: AxiosResponse<SavedSearchCriteriaResponse>) => response.data);

/**
 * (006005) 保存済み検索条件削除
 * @param projectId
 * @param criteria
 */
export const deleteSearchCriteria = (projectId: string, criteria: SavedSearchCriteriaCommonModel): Promise<void> => http.delete(`/projects/${projectId}/search-criterias/${criteria.search_criteria_id}`);
